module.exports = {
  QuickSearchAdNumber: 'Quick Search: Ad Number',
  Remove: 'Remove',
  Publish: 'Publish',
  AdNumber: 'Ad Number',
  SubjectName: 'Subject/Name',
  AdContent: 'Ad Content',
  Advertiser: 'Advertiser',
  AdPosition: 'Ad Position',
  BelongToPage: 'Belong to Page',
  BelongToModule: 'Belong to Module',
  BelongToSystem: 'Belong to System',
  Status: 'Status',
  TargetAudience: 'Target Audience',
  Global: 'Global',
  Creator: 'Creator',
  CreationDate: 'Creation Date',
  Modifier: 'Modifier',
  ModificationDate: 'Modification Date',
  PromotionPeriod: 'Promotion Period',
  EffectiveTime: 'Effective Time',
  ExpirationTime: 'Expiration Time',
  PleaseCheckOneEntry: 'Please check one entry!',
  ContainsUnremovedData: 'Contains unremoved data!',
  AreYouWantToDelete: 'Are you sure you want to delete?',
  PleaseSelectOneEntry: 'Please select one entry!',
  PleaseOnlySelectOneRecord: 'Please only select one record!',
  ContainsAlreadyRemovedData: 'Contains already removed data!',
  AreYouWantToRemove: 'Are you sure you want to remove?',
  AreYouWantToPublish: 'Are you sure you want to publish?',
  ThePositionHasBeenDisabled: 'The ad position has been disabled!',
  TheReachedTheMaximumPlacements: 'The ad position has reached the maximum number of placements!',
  RemainingAreNotEnoughCheck: 'Remaining ad positions are not enough, please check!',
  ContainsPublishedOrExpiredData: 'Contains already published or expired data!',
  View: 'View',
  Edit: 'Edit',
  Enable: 'Enable',
  Disable: 'Disable',
  AdPositionNumber: 'Ad Position Number',
  CurrentlyPlacedAdCount: 'Currently placed ad count',
  MaximumSupportedAdCount: 'Maximum supported ad count',
  CurrentDisabledAndCannotEdited: 'Current data is not disabled and cannot be edited!',
  AreYouWantToDisable: 'Are you sure you want to disable?',
  AreYouWantToDisable2: 'Are you sure you want to disable?',
  ContainsNonDisabledData: 'Contains non-disabled data!',
  AreYouWantToEnable: 'Are you sure you want to enable?',
  TemplateManagement: 'Template Management',
  TemplateTypeManagement: 'Template Type Management',
  ConfigurationManagement: 'Configuration Management',
  MappingManagement: 'Mapping Management',
  InitializeTemplateManagement: 'Initialize Template Management',
  BusinessStatusManagement: 'Business Status Management',
  TriggerTypeManagement: 'Trigger Type Management',
  FileTypeManagement: 'File Type Management',
  DefaultValueManagement: 'Default Value Management',
  ValidationRuleConfiguration: 'Validation Rule Configuration',
  EDITemplateSetting: 'EDI Template Setting',
  SeaFreightOnlineCheckingSettings: 'Sea Freight Online Checking Settings',
  ShippingRouteAndWarehouseConfiguration: 'Shipping Route and Warehouse Configuration',
  PushServiceConfiguration: 'Push Service Configuration',
  InvoiceCustomRemark: 'Invoice Custom Remark',
  CustomRemarkOne: 'Custom Remark one',
  CustomRemarkTwo: 'Custom Remark two',
  EmailTemplateManagement: 'Email Template Management',
  ReleaseConfiguration: 'Release Configuration',
  PromotionTimeRange: 'Promotion Time Range',
  JumpLink: 'Jump Link',
  Cancel: 'Cancel',
  Save: 'Save',
  Return: 'Return',
  Homepage: 'Homepage',
  SelectAll: 'Select All',
  DeselectAll: 'Deselect All',
  AreYouWantToCancel: 'Are you sure you want to cancel?',
  NumberOfClickedUsers: 'Number of Clicked Users',
  BelongToCompany: 'Belong to Company',
  UserType: 'User Type',
  Username: 'Username',
  PlatformCustomerService: 'Platform Customer Service',
  ClickTime: 'Click Time',
  BrowsingTime: 'Browsing Time',
  StartTime: 'Start Time:',
  EndTime: 'End Time:',
  SequenceNumber: 'Sequence Number',
  Code: 'Code',
  ChineseName: 'Chinese Name',
  EnglishName: 'English Name',
  NodeType: 'Node Type',
  Remarks: 'Remarks',
  CreateStatus: 'Create Status',
  Delete: 'Delete',
  IsItPublic: 'Is it public',
  CreateStatusDetail: 'Create Status Detail',
  EditStatus: 'Edit Status',
  DeleteSuccessful: 'Delete Successful',
  SaveSuccessful: 'Save Successful',
  PleaseEnterCode: 'Please enter code',
  PleaseEnterNodeType: 'Please enter node type',
  PleaseEnterCodeChineseName: 'Please enter code Chinese name',
  PleaseEnterCodeEnglishName: 'Please enter code English name',
  StatusType: 'Status Type',
  ExternalCode: 'External Code',
  Name: 'Name',
  GenerateElectronicFile: 'Generate Electronic File',
  FileType: 'File Type',
  DataService: 'Data Service',
  ReportTemplate: 'Report Template',
  PushObject: 'Push Object',
  PushChannel: 'Push Channel',
  SubjectTemplate: 'Subject Template',
  BodyTemplate: 'Body Template',
  DataItem: 'Data Item',
  AttachmentFileType: 'Attachment File Type',
  TemplateSubject: 'Template Subject',
  TemplateContent: 'Template Content',
  TemplateExample: 'Template Example',
  SendTest: 'Send Test',
  ConfigureSOPMessagePush: 'Configure SOP Message Push',
  EditStatusDetail: 'Edit Status Detail',
  InitialStatus: 'Initial Status',
  AutoTrigger: 'Auto Trigger',
  StatusChangeNotification: 'Status Change Notification',
  SendNotification: 'Send Notification',
  NoNotification: 'No Notification',
  DesignatedPosition: 'Designated Position',
  Sales: 'Sales',
  Operation: 'Operation',
  CustomerService: 'Customer Service',
  OverseasCustomerService: 'Overseas Customer Service',
  Documentation: 'Documentation',
  ShippingLineManager: 'Shipping Line Manager',
  DesignatedPersonnel: 'Designated Personnel',
  Email: 'Email',
  SopPushLog: 'sop push log',
  Confirm: 'Confirm',
  SendTo: 'Send to:',
  Note: 'Note',
  WillBusinessDetailsAndNodes: 'Will delete associated business details and SOP nodes',
  PleaseEnterContent: 'Please enter content',
  NotStarted: 'Not started',
  InProgress: 'In progress',
  Completed: 'Completed',
  Abnormal: 'Abnormal',
  BookingSuccessful: 'Booking successful',
  WarehouseEntryNotice: 'Warehouse entry notice',
  CustomsClearance: 'Customs clearance',
  SailingNotice: 'Sailing notice',
  IssuanceOfBillOfLading: 'Issuance of bill of lading',
  Customer: 'Customer',
  DestinationPortAgent: 'Destination port agent',
  DesignatedFreightForwarder: 'Designated freight forwarder',
  DeparturePortAgent: 'Departure port agent',
  DesignatedPositionsAndPersonnel: 'Designated positions and personnel',
  PleaseEnterTheCode: 'Please enter the code',
  PleaseEnterTheChineseName: 'Please enter the Chinese name',
  ChineseNameLengthExceeded20: 'Chinese name length exceeded 20!',
  PleaseEnterTheEnglishName: 'Please enter the English name',
  PleaseSelectTheStatusType: 'Please select the status type!',
  PleaseSelectTheTriggerType: 'Please select the trigger type',
  PleaseSelectTheStatusType2: 'Please select the status type',
  TheAlreadyExistsPleaseEnter: 'The same code already exists, please re-enter!',
  TheAlreadyExistsPleaseEnter2: 'The same Chinese name already exists, please re-enter!',
  TheAlreadyExistsPleaseEnter3: 'The same English name already exists, please re-enter!',
  SaveSuccess: 'Save success',
  DeleteSuccess: 'Delete success',
  BusinessDetailsDoNotExist: 'Business details do not exist',
  PleaseEnterTheSubjectTemplate: 'Please enter the subject template',
  PleaseTheTextTemplateContent: 'Please enter the text template content',
  PleaseEnterTheTemplateContent: 'Please enter the template content',
  PleaseEnterTheTemplateExample: 'Please enter the template example',
  PleaseFirstSelectData: 'Please first select data',
  AreWantToDeleteRecord: 'Are you sure you want to delete the selected record?',
  Tips: 'Tips',
  PleaseTheTestEmailAddress: 'Please enter the test email address!',
  EmailFormatError: 'Email format error!',
  EmailCannotExceed128Characters: 'Email length cannot exceed 128 characters',
  PleaseTestMobilePhoneNumber: 'Please enter the test mobile phone number!',
  MobileCanOnlyBeNumbers: 'Mobile phone number can only be valid numbers!',
  MobilePhoneNumberFormatError: 'Mobile phone number format error!',
  SendSuccess: 'Send success!',
  SendFailure: 'Send failure!',
  APIOutputAdditionalInformation: 'API output additional information',
  OutputDescription: 'Output description',
  OutputIdentification: 'Output identification',
  DataSource: 'Data source',
  DataField: 'Data field',
  WarningSwitch: 'Warning switch',
  SailingTimeETD: 'Sailing time (ETD)',
  ArrivalTimeETA: 'Arrival time (ETA)',
  OpenPortTime: 'Open port time',
  ClosingPortTime: 'Closing port time',
  ClosingTimeForOrders: 'Closing time for orders',
  CustomsClosingTime: 'Customs closing time',
  ScheduledBerthingDate: 'Scheduled berthing date',
  ScheduledDepartureDate: 'Scheduled departure date',
  WarningTime: 'Warning time',
  Advance: 'Advance',
  Delay: 'Delay',
  WarningSettings: 'Warning settings',
  TurnOnWarning: 'Turn on warning',
  TurnOffWarning: 'Turn off warning',
  HoursWarningReminder: 'Hours, warning reminder',
  Highest: 'Highest',
  High: 'High',
  Medium: 'Medium',
  Low: 'Low',
  Relation: 'Relation',
  FilterValue: 'Filter value',
  ValidationCondition: 'Validation condition',
  New: 'New',
  And: 'And',
  Or: 'Or',
  FilterBasis: 'Filter basis',
  CurrentlyModeUnableToNew: 'Currently in edit mode, unable to create new',
  CurrentlyModeUnableToDelete: 'Currently in edit mode, unable to delete',
  PleaseSelectAFilterBasis: 'Please select a filter basis',
  PleaseSelectTheFilterValue: 'Please select the filter value',
  ValidationExpression: 'Validation expression',
  PositiveOperation: 'Positive operation',
  PreSubmit: 'Pre-submit',
  Submitted: 'Submitted',
  Reviewed: 'Reviewed',
  ValidationItem: 'Validation item',
  Empty: 'Empty',
  PleaseSelectValidationItem: 'Please select validation item',
  RuleName: 'Rule name',
  ValidationNode: 'Validation node',
  ValidationType: 'Validation type',
  ValidationMode: 'Validation mode',
  EmailAddress: 'Email address',
  Add: 'Add',
  Refresh: 'Refresh',
  ValidationRules: 'Validation rules',
  AllowOperationAfterValidationFails: 'Allow to continue operation after validation fails?',
  Yes: 'Yes',
  No: 'No',
  Company: 'Company',
  ContinueValidation: 'Continue validation',
  CurrentlyYouSureYouRefresh: 'Currently in edit mode, are you sure you want to refresh?',
  FailedToInitializeData: 'Failed to initialize data',
  AreRuleAssociatedValidationDeleted: 'Are you sure you want to delete this validation rule? Associated validation expressions and validation conditions will also be deleted!',
  PleaseSelectTheBranchOffice: 'Please select the branch office',
  PleaseEnterTheRuleName: 'Please enter the rule name',
  PleaseSelectTheRuleNode: 'Please select the rule node',
  PleaseSelectTheRuleType: 'Please select the rule type',
  PleaseSelectTheRuleMode: 'Please select the rule mode',
  CompanyName: 'Company name',
  PleaseConfigurationNameOrRemarks: 'Please enter the configuration name or remarks',
  Type: 'Type',
  InterfaceSettings: 'Interface settings',
  ConfigurationName: 'Configuration name',
  DefaultValue: 'Default value',
  EditConfigurationItem: 'Edit configuration item',
  EditConfigurationDefinition: 'Edit configuration definition:',
  Search: 'Search',
  ConfigurationItemconfigId: 'Configuration item (configId)',
  TypedataType: 'Type (dataType)',
  InterfaceSettingsisClient: 'Interface settings (isClient)',
  BranchOfficeOptionisOfficeOption: 'Branch office option (isOfficeOption)',
  ServiceSettingsisServer: 'Service settings (isServer)',
  OptionalItemliterals: 'Optional item (literals)',
  ConfigurationNamename: 'Configuration name (name)',
  Remarksremarks: 'Remarks (remarks)',
  DefaultValuevalue: 'Default value (value)',
  ConfigurationNameCannotBeEmpty: 'Configuration name cannot be empty',
  DefaultValueCannotBeEmpty: 'Default value cannot be empty',
  PleaseEnterTheBranchOffice: 'Please enter the branch office',
  Value: 'Value',
  ConfigurationItem: 'Configuration item',
  BranchOffice: 'Branch office',
  PleaseSelectAConfigurationDefinition: 'Please select a configuration definition',
  BranchOfficeCannotBeEmpty: 'Branch office cannot be empty!',
  ValueCannotBeEmpty: 'Value cannot be empty!',
  TheConfigurationAlreadyExistsCheck: 'The same branch office configuration already exists, please check',
  ApplyHeadOfficeSettings: 'Apply head office settings',
  SleepingDays: 'Sleeping days',
  SigningDays: 'Signing days',
  NotificationObject: 'Notification object:',
  Supervisor: 'Supervisor',
  NotificationMethod: 'Notification method:',
  InternalReminder: 'Internal reminder',
  HowDaysBeforeExpirationNotice: 'How many days before expiration notice:',
  Days: 'Days',
  DayMaintenance: 'Day maintenance:',
  BusinessEntity: 'Business entity',
  SelectEntityConfigurationItem: 'Select entity configuration item',
  BranchOffice2: 'Branch office:',
  EntitySelection: 'Entity selection:',
  AffiliatedBranchOffice: 'Affiliated branch office',
  EntityCode: 'Entity code',
  EntityName: 'Entity name',
  FieldCode: 'Field code',
  FieldName: 'Field name',
  ValueType: 'Value Type',
  All: 'All',
  SelectBranch: 'Select Branch',
  Unused: 'Unused',
  Used: 'Used',
  Example8180ThisTicketOnlyDollars: 'Example: USD:355/Exchange Rate:6.8180/This ticket only accepts US dollars',
  Precautions: 'Precautions:',
  SavedEffectFromTheInvoice: 'Saved settings will take effect from the next invoice',
  EBeLessThanCharacters: 'E-ticket remarks must be less than 100 characters',
  PaperBeLessThanCharacters: 'Paper ticket remarks must be less than 200 characters',
  AutomaticallyALineDoesShow: 'Automatically wrap when a line does not show',
  PDFCanDisplayUpLines: 'PDF format invoice remark column can display up to three lines',
  SerialNumber: 'Serial Number',
  ExternalFileType: 'External File Type',
  NecessaryScenario: 'Necessary Scenario',
  OriginalScenario: 'Original Scenario',
  TypePermission: 'Type Permission',
  AllPositions: 'All Positions',
  Client: 'Client',
  Shipper: 'Shipper',
  Consignee: 'Consignee',
  OverseasAgent: 'Overseas Agent',
  BookingAgent: 'Booking Agent',
  ExternalAccess: 'External Access',
  B2BCustomer: 'B2B Customer',
  B2BDesignatedCargoAgent: 'B2B Designated Cargo Agent',
  B2BDestinationPortAgent: 'B2B Destination Port Agent',
  B2BConsignee: 'B2B Consignee',
  TemplateOutputName: 'Template Output Name',
  Delimiter: 'Delimiter',
  NoteTemplateNameAccordingNeeds: 'Note: Please define the export template name according to your needs',
  DefaultSync: 'Default Sync',
  UsedFileAutomaticallySynchronizesBusiness: 'Used for setting whether this type of file automatically synchronizes between export and import business',
  CustomTemplateName: 'Custom Template Name',
  TemplateName: 'Template Name',
  Underscore_: 'Underscore _',
  Hyphen: 'Hyphen -',
  CreateFileClassification: 'Create File Classification',
  CreateFileType: 'Create File Type',
  Create: 'Create',
  Modify: 'Modify',
  FileClassification: 'File Classification',
  CurrentOperationStatusIsAbnormal: 'Current operation status is abnormal!',
  PleaseSelectChineseName: 'Please select Chinese name',
  CurrentOperatingStatusAbnormal: 'Current operating status abnormal',
  CondAlreadyExists: 'cond already exists',
  EDIFileDefaultTypeDefaultFileType: 'EDI File Default Type(DefaultFileType)',
  Emailemail: 'Email (email)',
  EDIFileEncodingTypeEncodingType: 'EDI File Encoding Type(EncodingType)',
  EDIFileCombinationMethodFileCombineType: 'EDI File Combination Method(FileCombineType)',
  PartnerCodeParnterId: 'Partner Code (ParnterId)',
  SendFTPFileNamePrefixsendFilePrefix: 'Send FTP file name prefix(sendFilePrefix)',
  SendFTPAddressTypesendType: 'Send FTP address type(sendType)',
  ServiceTypeServiceType: 'Service Type (ServiceType)',
  TemplateDescriptionTemplateDescribe: 'Template Description (TemplateDescribe)',
  TemplateAccessPathTemplatePath: 'Template Access Path (TemplatePath)',
  TemplateTypeTemplateType: 'Template Type (TemplateType)',
  ShutNoticeShutOutIdentification: 'Shut-out notice (Shut-out identification)',
  EDITemplateMaintenance: 'EDI Template Maintenance',
  PleaseEDIFileCombinationMethod: 'Please enter EDI file combination method',
  EDIMethodMustBeType: 'EDI file combination method must be numeric type',
  PleaseEnterPartnerCode: 'Please enter partner code',
  PartnerMustBeNumericType: 'Partner code must be numeric type',
  PleaseEnterServiceType: 'Please enter service type',
  ServiceMustBeNumericType: 'Service type must be numeric type',
  PleaseEnterTemplateDescription: 'Please enter template description',
  PleaseEnterTemplateAccessPath: 'Please enter template access path',
  PleaseEnterTemplateType: 'Please enter template type',
  TemplateMustBeNumericType: 'Template type must be numeric type',
  ShutMustBeNumericType: 'Shut-out notice must be numeric type',
  CloudStorageID: 'Cloud Storage ID',
  TemplateFileCloudStorage: 'Template File Cloud Storage',
  PleaseTemplateYouWantEdit: 'Please select the template you want to edit!',
  PleaseTemplateYouWantDelete: 'Please select the template you want to delete!',
  ConfirmDeletionOfThisTemplate: 'Confirm deletion of this template?',
  TemplateDeletedSuccessfully: 'Template deleted successfully!',
  TemplateDeletionFailed: 'Template deletion failed!',
  BasicFailedPleaseTryAgain: 'Basic template update failed, please try again!',
  BasicTemplateUpdateSuccessful: 'Basic template update successful!',
  PleaseEnterKeywordsToSearch: 'Please enter keywords to search',
  EmailTemplateEditing: 'Email template editing',
  PushingLink: 'Pushing link',
  TextTemplate: 'Text Template',
  Reminder: 'Reminder',
  SendEmail: 'Send email:',
  OK: 'OK',
  BasicData: 'Basic Data',
  SystemEmail: 'System Email',
  PicturePictureMustNot10M: 'Picture upload failed, picture must not exceed 10M!',
  PleaseAddProductDescriptionHere: 'Please add product description here',
  PreSendingSupplementaryInvitationLink: 'Pre-stowage information sending supplementary invitation link',
  MarineMBLInvitationForProofreading: 'Marine Export MBL Invitation for Proofreading',
  MarineHBLInvitationForProofreading: 'Marine Export HBL Invitation for Proofreading',
  MarineExportBulkPrinting: 'Marine Export Bulk Printing',
  AirCargoStorage: 'Air Cargo Storage',
  BillOfLadingPrintProduction: 'Bill of Lading Print Production',
  FileHistory: 'File History',
  InvoicePush: 'Invoice push',
  OceanShippingAlertReminderEmail: 'Ocean Shipping - Alert Reminder Email',
  ReminderEmail: 'Reminder Email',
  AirExportAlertReminderEmail: 'Air Export - Alert Reminder Email',
  RailwayAlertReminderEmail: 'Railway - Alert Reminder Email',
  AirImportAlertReminderEmails: 'Air Import - Alert Reminder Emails',
  IntegratedAlertReminderEmails: 'Integrated - Alert Reminder Emails',
  BookingPageData: 'Booking page data',
  ContentTemplate: 'Content Template',
  Updater: 'Updater',
  LastUpdateTime: 'Last Update Time',
  UploadedBeLargerThan20MB: 'Uploaded pictures cannot be larger than 20MB',
  PictureInsertionFailed: 'Picture insertion failed',
  OnlyVieweditOneEmailTemplate: 'Only allowed to view/edit one email template',
  CompanyEmail: 'Company Email',
  PersonalEmail: 'Personal Email',
  SentSuccessfully: 'Sent successfully!',
  ConfirmTheModifiedContent: 'Confirm the modified content?',
  ConfirmCancelingTheFilledmodifiedContent: 'Confirm canceling the filled/modified content?',
  PleaseInTheRecipientsEmail: 'Please fill in the recipient\'s email!',
  MappingType: 'Mapping Type',
  Description: 'Description',
  Condition: 'Condition',
  SendingPlatform: 'Sending Platform',
  EnglishName2: 'English Name',
  ChineseName2: 'Chinese Name',
  OriginalValue: 'Original Value',
  NewValue: 'New Value',
  EditMapping: 'Edit Mapping',
  CreateMapping: 'Create Mapping',
  PleaseEnterMappingType: 'Please enter mapping type',
  PleaseEnterTheOriginalValue: 'Please enter the original value',
  PleaseEnterTheNewValue: 'Please enter the new value',
  Branch: 'Branch',
  EnableAutomaticPush: 'Enable Automatic Push',
  SOPPushChannel: 'SOP Push Channel:',
  PushOnlyAfterConfirmingRecipient: 'Push SOP Status only after confirming SOP recipient:',
  PleaseSendersEmailWhichEmails: 'Please tick the box below to set the sender\'s email, which can be used when sending emails.',
  Username2: 'Username:',
  EmailPasswordauthorizationCode: 'Email password/authorization code:',
  EmailDisplayName: 'Email display name:',
  SenderServer: 'Sender server:',
  Port: 'Port:',
  WhenActualSenderIsEmail: 'When choosing a personal email, the actual sender is each user\'s registered email.',
  CompanyEnglishAbbreviation: 'Company English abbreviation:',
  BasicConfiguration: 'Basic configuration',
  SMS: 'SMS',
  Open: 'Open',
  Close: 'Close',
  EmailConfiguration: 'Email configuration',
  Signature: 'Signature:',
  EnableSignature: 'Enable signature',
  SMSConfiguration: 'SMS configuration',
  PleaseAProductDescriptionHere: 'Please add a product description here',
  CompanyAbbreviationCannotBeEmpty: 'Company Chinese abbreviation cannot be empty!',
  CompanyUsernameCannotBeEmpty: 'Company email username cannot be empty!',
  CompanyCodeCannotBeEmpty: 'Company email password/authorization code cannot be empty!',
  CompanyServerCannotBeEmpty: 'Company email sender server cannot be empty!',
  CompanyNumberMustBeNumber: 'Company email port number must be a number!',
  PersonalUsernameCannotBeEmpty: 'Personal email username cannot be empty!',
  PersonalServerCannotBeEmpty: 'Personal email sender server cannot be empty!',
  PersonalNumberMustBeNumber: 'Personal email port number must be a number!',
  AdditionalOutputAssociatedTemplate: 'Additional output associated template',
  TemplateEngine: 'Template engine',
  FilterScript: 'Filter script',
  BranchSerialNumber: 'Branch serial number',
  TemplateFile: 'Template file',
  TemplateClass: 'Template class',
  TemplateUsage: 'Template usage',
  Print: 'Print',
  CreateTemplate: 'Create template',
  TemplateFileCloudStorageID: 'Template file cloud storage ID',
  TemplateSerialNumber: 'Template serial number',
  SchemaTypeNotMaintained: 'SchemaType not maintained',
  CannotCheckWhetherTheCorrect: 'Cannot query basic template information, please check whether the template data source is correct!',
  SchemaTypeCannotBeEmpty: 'Schema Type cannot be empty.',
  TemplateTypeCannotBeEmpty: 'Template Type cannot be empty',
  TemplateDescCannotBeEmpty: 'Template Type Desc cannot be empty',
  ChineseNameLengthExceeds20: 'Chinese name length exceeds 20!',
  PleaseSelectStatusType: 'Please select status type!',
  PleaseSelectATriggerType: 'Please select a trigger type',
  DropThisConditionForGoods: '*Drop-down box is empty means not considering this condition. For example, not considering the type of goods',
  PushTarget: 'Push target',
  BookingSuccess: 'Booking success',
  WarehouseEntryNotification: 'Warehouse entry notification',
  BillOfLadingIssuance: 'Bill of lading issuance',
  DesignatedFreightAgent: 'Designated freight agent',
  DesignatedPostAndDesignatedPersonnel: 'Designated post and designated personnel',
  PleaseSelectDataFirst: 'Please select data first',
  AreToDeleteTheRecord: 'Are you sure to delete the selected record?',
  Hint: 'Hint',
  PleaseEnterTestEmailAddress: 'Please enter test email address!',
  PleaseEnterTestMobileNumber: 'Please enter test mobile number!',
  MobileOnlyBeANumber: 'Mobile number can only be a valid number!',
  MobileNumberFormatError: 'Mobile number format error!',
  SendingSuccessful: 'Sending successful!',
  SendingFailed: 'Sending failed!',
  ChineseName3: 'Chinese name',
  EnglishName3: 'English name',
  PublicOrNot: 'Public or not',
  Remark: 'Remark',
  AutomaticTrigger: 'Automatic trigger',
  DoNotSendNotification: 'Do not send notification',
  DesignatedPost: 'Designated post',
  Documentary: 'Documentary',
  LineManager: 'Line manager',
  PleaseEnterChineseName: 'Please enter Chinese name',
  PleaseEnterEnglishName: 'Please enter English name',
  PleaseSelectTriggerType: 'Please select trigger type',
  PleaseSelectStatusType2: 'Please select status type',
  ThereSameCodePleaseEnter: 'There already exists the same code, please re-enter!',
  ThereSameChineseNameEnter: 'There already exists the same Chinese name, please re-enter!',
  ThereSameEnglishNameEnter: 'There already exists the same English name, please re-enter!',
  PleaseEnterFieldName: 'Please enter field name',
  PleaseEnterFieldEnglishName: 'Please enter field English name',
  AreToDeleteTheType: 'Are you sure to delete the trigger type?',
  AllCharts: 'All charts',
  BusinessCharts: 'Business charts',
  FinancialCharts: 'Financial charts',
  ControlMode: 'Control mode:',
  ReceivingOrder: 'Receiving order',
  Printing: 'Printing',
  BillOfLadingRelease: 'Bill of lading release',
  NoDeduction: 'No deduction',
  OnlyHBL: 'Only HBL',
  OnlyHBLDeductHBL: 'Only HBL deduct HBL',
  OnlyMBL: 'Only MBL',
  OnlyMBLDeductMBL: 'Only MBL deduct MBL',
  HBLAtTheSameTime: 'HBL & MBL at the same time',
  HBLAtTheSameTime2: ' HBL, MBL deducted at the same time',
  OnlyHBLWithoutDeductingMBL: ' Only deduct HBL without deducting MBL',
  DoHBLOnlyDeductMBL: 'Do not deduct HBL, only deduct MBL',
  DocumentCirculation: 'Document circulation',
  ApplyTheHeadOfficesSettings: 'Apply the head office\'s settings',
  ReminderMode: 'Reminder mode',
  LockingMode: 'Locking mode',
  WhenRemindersAndTheLocked: 'When the credit control exceeds, only send reminders, and the work order will not be locked',
  WhenOrderUntilItApproved: 'When the credit control exceeds, lock the work order until it is automatically unlocked or manually approved',
  NotificationReminder: 'Notification reminder:',
  LockingControl: 'Locking control:',
  Event: 'Event',
  IsLocked: 'Is Locked',
  ControlObject: 'Control Object',
  ControlMethod: 'Control Method',
  PrintTemplate: 'Print Template',
  Document: 'Document',
  EmailAndReminder: 'Email and Reminder',
  None: 'None',
  SaveAndLock: 'Save and Lock',
  CannotSave: 'Cannot Save',
  BusinessLocked: 'Business Locked',
  BusinessUnlocked: 'Business Unlocked',
  CreditControlExceed: 'Credit Control Exceed',
  CreditControlChange: 'Credit Control Change',
  AddCopyFormalBusiness: 'Add/Copy Formal Business',
  OperationSupervisor: 'Operation Supervisor',
  SalesSupervisor: 'Sales Supervisor',
  CreditControlSupervisor: 'Credit Control Supervisor',
  BusinessCustomerService: 'Business Customer Service',
  MBLTabPrint: 'MBL Tab Print',
  MBLSplitMergePrint: 'MBL Split/Merge Print',
  HBLOriginalPrint: 'HBL Original Print',
  HBLSplitMergeOriginalPrint: 'HBL Split/Merge Original Print',
  HBLTelexPrint: 'HBL Telex Print',
  HBLSplitMergeTelexPrint: 'HBL Split/Merge Telex Print',
  BookingTabPrint: 'Booking Tab Print',
  BasicTab: 'Basic Tab',
  MAWBTab: 'MAWB Tab',
  HAWBTab: 'HAWB Tab',
  BookingEDI: 'Booking EDI',
  BillOfLadingEDI: 'Bill of Lading EDI',
  ReturnOrder: 'Return Order',
  AbnormalStatus: 'Abnormal Status',
  User: 'User',
  IPAddress: 'IP Address',
  PleaseEnterTheIPAddress: 'Please enter the IP address.',
  IndicatesUnrestricted: 'Indicates unrestricted',
  IPAddressCannotBeEmpty: 'IP address cannot be empty',
  PleaseSelectAUser: 'Please select a user',
  ThisAlreadyAddedAnWhitelist: 'This user has already added an IP whitelist',
  ExistingSameIPAddress: 'Existing same IP address',
  PleaseSelectData: 'Please select data',
  BusinessType: 'Business Type',
  BillOfLadingType: 'Bill of Lading Type',
  DesignatedShippingLine: 'Designated Shipping Line',
  Expression: 'Expression',
  Example: 'Example',
  LetterSuffix: 'Letter Suffix',
  LetterexcludingIAndO: 'Letter Suffix (excluding I and O)',
  NumberSuffix: 'Number Suffix',
  MasterBillExtension: 'Master Bill Extension',
  SuffixSeparator: 'Suffix Separator',
  Constant: 'Constant',
  AddRule: 'Add Rule',
  PleaseEnterRuleName: 'Please enter rule name',
  Reset: 'Reset',
  ServiceCodeMaintenance: 'Service Code Maintenance',
  BusinessTypelob: 'Business Type (lob)',
  CargoPickupType: 'Cargo Pickup Type',
  BranchCodeoffice: 'Branch Code (office)',
  Salesperson: 'Salesperson',
  NetCodenetCode: 'Net Code (netCode)',
  SalesDepartment: 'Sales Department',
  OperationsDepartment: 'Operations Department',
  OverseasWarehouseCodeFBAFC: 'Overseas Warehouse Code (FBA FC)',
  PortCodeport: 'Port Code (port)',
  DeliveryPlaceCodeport: 'Delivery Place Code (port)',
  PolCode: 'Departure Port Code(POL)',
  DeparturePortCode: 'Departure Port Code',
  DestinationPortCode: 'Destination Port Code',
  DeparturePortExchangeCode: 'Departure Port Exchange Code',
  DestinationPortExchangeCode: 'Destination Port Exchange Code',
  ServiceCode: 'Service Code',
  OverseasAgentCode: 'Overseas Agent Code',
  JobNumberjobNo: 'Job Number (jobNo)',
  ReceivableOrPayable: 'Accounts Receivable and Payable (RP)',
  Jobyear: 'job (year)',
  Yearyear: 'Year (year)',
  Length: 'Length',
  Jobmonth: 'job (month)',
  Monthmonth: 'Month (month)',
  Dateday: 'Date (day)',
  JobSequenceNumberjobSequence: 'Job Sequence Number (jobSequence)',
  RandomLetters: 'Random Letters',
  SequenceNumbersequence: 'Sequence Number (sequence)',
  CustomBusinessTypecustomJobType: 'Custom Business Type (customJobType)',
  SequenceNumberSettings: 'Sequence Number Settings',
  NeverResetN: 'Never Reset (N)',
  ResetByYearY: 'Reset by Year (Y)',
  ResetByMonthM: 'Reset by Month (M)',
  ResetByDayD: 'Reset by Day (D)',
  BusinessDate: 'Business Date',
  DepartureDate: 'Departure Date',
  ShippingDate: 'Shipping Date',
  ArrivalDate: 'Arrival Date',
  BranchSequenceNumberIndependent: 'Branch Sequence Number Independent',
  CustomJobTypeSequenceNumberIndependent: 'Custom Job Type Sequence Number Independent',
  PaymentDirectionSerialNo: 'Payment direction serial number is independent',
  DomesticBill: 'Domestic Bill',
  DomesticBillNo: 'Domestic Bill Number',
  ReceivableAndPayableio: 'Receivable and Payable (io)',
  BranchConfigurationIndependent: 'Branch Configuration Independent',
  JoiningDeclarationNumberRule: 'Joining Declaration Number Rule',
  TakeBillDateOnYearMonthDay: 'Take the bill date on year, month, and day',
  TakeDocumentDateOnYearMonthDay: 'Year Month Day Date of Receipt Preparation',
  TakeActualPayDateOnYearMonthDay: 'Take the actual payment and receipt date from year month day',
  UseBillDateOnYearMonthDay: 'Use the reconciliation statement date as the year, month, and date serial number control.',
  UseDocumentDateOnYearMonthDay: 'Use the billing statement creation date as the year, month, and date serial number control.',
  UseActualPayDateOnYearMonthDay: 'Use actual receipts and payments as controls for year, month, date, and serial numbers.',
  DomesticStatement: 'Domestic statement',
  ForeignStatement: 'Foreign reconciliation statement',
  AddConstant: 'Add Constant',
  PleaseToJobNumberSettings: 'Please refer to Job Number Settings',
  ConstantCannotBeEmpty: 'Constant cannot be empty',
  ConstantSpecialCharacters$: 'Constant cannot contain special characters $, {, }',
  ConfigurationCannotBeEmpty: 'Configuration cannot be empty!',
  LengthExceedsAllowableLength: 'Length exceeds allowable length!',
  ConfigurationExpressionCannotBeEmpty: 'Configuration expression cannot be empty',
  ThereAtLeastOneName: 'There must be at least one rule name',
  JoiningMustChooseAtItem: 'Joining declaration number rule must choose at least one item',
  ChangingInTheSystemModification: 'Changing configuration may affect the query of historical data in the system, do you want to save the modification?',
  RuleNameAlreadyExists: 'Rule name already exists',
  SaveFailed: 'Save failed',
  AreWantToDeleteRule: 'Are you sure you want to delete this rule?',
  Prompt: 'Prompt',
  BranchBankAccount: 'Branch Bank Account',
  SetAsDefaultRMBAccount: 'Set as Default RMB Account',
  SetAsDefaultUSDAccount: 'Set as Default USD Account',
  Currency: 'Currency',
  Bank: 'Bank',
  Abbreviation: 'Abbreviation',
  AccountNumber: 'Account Number',
  RMBDefaultAccount: 'RMB Default Account',
  USDDefaultAccount: 'USD Default Account',
  BankChineseAddress: 'Bank Chinese Address',
  BankEnglishAddress: 'Bank English Address',
  TheItCannotBeAccount: 'The currency of this account is not RMB, it cannot be selected as the default RMB account.',
  TheItCannotBeAccount2: 'The currency of this account is not USD, it cannot be selected as the default USD account.',
  NameDoYouWantSave: ']Name already exists, do you want to save?',
  SaveWantToCloseWindow: 'Save successful, do you want to close the window?',
  CurrencyCannotBeEmpty: 'Currency cannot be empty',
  CodeCannotBeEmpty: 'Code cannot be empty',
  EnglishNameCannotBeEmpty: 'English name cannot be empty',
  AccountNumberCannotBeEmpty: 'Account number cannot be empty',
  TaxControlDiskNumberMaintenance: 'Tax Control Disk Number Maintenance',
  Number: 'Number',
  InvoiceCode: 'Invoice Code',
  UsageDepartment: 'Usage Department',
  TheNumberCannotBeRepeated: 'The number cannot be repeated!',
  InvoiceCodeCannotBeRepeated: 'Invoice Code cannot be repeated!',
  OneToMaintainMultipleNumbers: 'One department is not allowed to maintain multiple tax control disk numbers',
  NumberCannotBeEmpty: 'Number cannot be empty!',
  InvoiceCodeCannotBeEmpty: 'Invoice Code cannot be empty!',
  UsageDepartmentCannotBeEmpty: 'Usage Department cannot be empty!',
  DepartmentCode: 'Department code',
  JobNumberEncodingField: 'Job number encoding field',
  IsItASettlementCompany: 'Is it a settlement company',
  AddDepartment: 'Add department',
  TheOfTheDepartmentEmpty: 'The Chinese or English name of the department cannot be empty',
  EnabledSuccessfully: 'Enabled successfully!',
  DisabledSuccessfully: 'Disabled successfully!',
  SaveSuccessfully: 'Save successfully!',
  CompanyCode: 'Company code',
  BranchChineseName: 'Branch Chinese name',
  ChineseAddress: 'Chinese address',
  BranchEnglishName: 'Branch English name',
  City: 'City',
  PostalCode: 'Postal code',
  Fax: 'Fax',
  Phone: 'Phone',
  LocalCurrency: 'Local currency',
  DefaultAirport: 'Default airport',
  DefaultSeaport: 'Default seaport',
  SeaBillOfLadingAddress: 'Sea bill of lading address',
  AirBillOfLadingAddress: 'Air bill of lading address',
  RMBAccount: 'RMB account',
  USDAccount: 'USD account',
  OverseasBillAddress: 'Overseas bill address',
  DomesticBillAddress: 'Domestic bill address',
  OverseasEDICode: 'Overseas EDI code',
  MarkupTaxRate: 'Markup tax rate',
  InvoiceTaxRate: 'Invoice tax rate',
  SettlementEmail: 'Settlement email',
  TaxSystemInterfaceAddress: 'Tax system interface address',
  TaxControlPanelNumber: 'Tax control panel number',
  InvoiceTitle: 'Invoice title',
  InvoiceAddress: 'Invoice address',
  TaxpayerIdentificationNumber: 'Taxpayer identification number',
  ElectronicTicketPlatformCode: 'Electronic ticket platform code',
  ElectronicTicketPassword: 'Electronic ticket password',
  ElectronicTaxpayerIdentificationNumber: 'Electronic taxpayer identification number',
  ElectronicTaxpayerAuthorizationCode: 'Electronic taxpayer authorization code',
  ElectronicTicketServiceRequestAddress: 'Electronic ticket service request address',
  InvoiceCancellationRequestAddress: 'Invoice cancellation request address',
  RelatedPartners: 'Related partners',
  EFreighAMSAccount: 'E-Freigh(AMS account)',
  EFreighACIAccount: 'E-Freigh(ACI account)',
  CopyCompany: 'Copy company',
  AddBranch: 'Add branch',
  CopyBranch: 'Copy branch',
  BankAccount: 'Bank account',
  SelectFile: 'Select file',
  RemoveFile: 'Remove file',
  NewBranchInformation: 'New branch information',
  N1DepartmentsAndPositionBranch: '1. Permission management in all departments and position permissions of the branch',
  N2ParameterConfiguration: '2. Parameter configuration',
  N3OrderNumberConfiguration: '3. Order number configuration',
  Preview: 'Preview',
  Apply: 'Apply',
  CompanyCodeCannotBeEmpty2: 'Company code cannot be empty.',
  TheOfTheCompanyEmpty: 'The Chinese or English name of the company cannot be empty.',
  LocalNotAllowedToEmpty: 'Local currency is not allowed to be empty.',
  CopyCompanySucceeded: 'Copy company succeeded',
  AreYouSureToDelete: 'Are you sure to delete?',
  DeletedSuccessfully: 'Deleted successfully.',
  NameCannotBeEmpty: 'Name cannot be empty',
  SubmitSuccessfully: 'Submit successfully',
  RoleName: 'Role name',
  PleaseSelect: 'Please select',
  Individual: 'Individual',
  DepartmentGroup: 'Department group',
  BatchAddRolePermissions: 'Batch add role permissions',
  UpdatePermissionGroup: 'Update permission group',
  Removegtgt: 'Remove&gt;&gt;',
  ltltAdd: '&lt;&lt;Add',
  PermissionName: 'Permission name',
  PermissionClass: 'Permission class',
  PermissionType: 'Permission type',
  PermissionPoint: 'Permission point',
  Error: 'Error',
  AreDeleteTheCurrentlyRoles: 'Are you sure to delete the currently selected ',
  PleaseOrMoreRolesDelete: 'Please select one or more roles to delete!',
  PleaseOneOrMoreRoles: 'Please select one or more roles',
  PleaseOneOrMorePermissions: 'Please select one or more permissions',
  BatchAddSuccessfully: 'Batch add successfully',
  PleaseEnterTheRoleName: 'Please enter the role name',
  Meaning: 'Meaning',
  PleaseEnterTheServiceCode: 'Please enter the service code',
  PleaseTheServiceCodeMeaning: 'Please enter the service code meaning',
  Defaulted: 'Defaulted',
  SetAsDefault: 'Set as default',
  SuccessSetting: 'Success setting',
  AreToDeleteThisCode: 'Are you sure to delete this service code',
  SelectCustomer: 'Select customer',
  PleaseCodeEnglishNameName: 'Please enter acronym, code, English name, Chinese name',
  PleaseSelectACustomer: 'Please select a customer.',
  DataCargoTrackingPurchaseEffect: 'Data push service items: Port ship schedule, port cargo data, shipping company cargo tracking. Purchase data push service and configure this page to take effect',
  PushFCLLCLType: 'Push FCL/LCL type',
  PleaseSelectFCLLCLType: 'Please select FCL/LCL type',
  DoServicesNeedToVoyage: 'Do port ship schedule data push services need to update ship name and voyage',
  IsTrackingLimitedToDeparture: 'Is shipping company cargo tracking limited to port of departure',
  EnterpriseType: 'Enterprise type',
  SelectServiceEnabledSelectEffect: 'Select All to set all customers to open push service; select White List for customers who have push service enabled; select Black List for customers who have push service disabled, only the last saved setting will take effect.',
  WhiteList: 'White List',
  BlackList: 'Black List',
  DeleteConfiguration: 'Delete configuration',
  PushCondition: 'Push condition',
  DataSettings: 'Data settings',
  SynchronizationLogicSettings: 'Synchronization logic settings',
  ClearSettings: 'Clear settings',
  unBerthPlanDateSynETD: 'Synchronize ETD with planned departure time',
  estimatedArrivalTimeSynETA: 'Expected arrival time synchronized with ETA',
  ClearVoyageAndShipPeriodData: 'Clear, modify ship name, voyage, and clear shipping schedule data',
  MorePushConfiguration: 'More push configuration...',
  PortPortOfDepartureRange: 'Port data push port of departure range',
  Shanghai: 'Shanghai',
  Ningbo: 'Ningbo',
  Xiamen: 'Xiamen',
  Shenzhen: 'Shenzhen',
  Qingdao: 'Qingdao',
  Tianjin: 'Tianjin',
  Fuzhou: 'Fuzhou',
  Dalian: 'Dalian',
  NanSha: 'NanSha',
  CustomerList: 'Customer list',
  CloseOpen: 'Turn off the settings for opening data services',
  DataServiceSetting: 'Data Service Settings',
  DataServiceNotUpdateValue: 'The data service does not update the value of this field',
  ConditionType: 'Condition type',
  PleaseSelectConsignor: 'Please select the commissioning unit',
  SubscriptionScope: 'Subscription scope',
  Consignor: 'Consignor',
  NoConfigurationItemsMade: 'No configuration items made.',
  DeletedSuccessfully2: 'Deleted successfully!',
  FCLLCLTypeNotSelected: 'FCL/LCL type not selected',
  PleaseSelectWhiteListCustomers: 'Please select white list customers',
  PleaseSelectBlackListCustomers: 'Please select black list customers',
  SavedSuccessfully: 'Saved successfully!',
  PleaseLeastOneDataDeletion: 'Please select at least one data for deletion!',
  PushServiceProviderConfiguration: 'Push service provider configuration',
  PushServiceName: 'Push service name',
  ServiceProviders: 'Service Providers',
  ShanghaiPort: 'Shanghai Port',
  ShippingCompanyCargoTracking: 'Shipping company cargo tracking',
  Seabourne: 'Seabourne',
  FreighTower: 'Freigh Tower',
  AirCargoTracking: 'Air cargo tracking',
  MaritimeDataPush: 'Maritime Data Push',
  AirFreightDataPush: 'Air Freight Data Push',
  YundangNet: 'YundangNet',
  SeaButler: 'Sea Butler',
  NingboPort: 'Ningbo Port',
  XiamenPort: 'Xiamen Port',
  QingdaoPort: 'Qingdao Port',
  FuzhouPort: 'Fuzhou Port',
  PortShipSchedule: 'Port ship schedule',
  ShenzhenPort: 'Shenzhen Port',
  DalianPort: 'Dalian Port',
  TianjinPort: 'Tianjin Port',
  DataPushCustomerList: 'Data push customer list',
  CustomerWhitelist: 'Customer whitelist:',
  PushContent: 'Sea Push content',
  AirPushContent: 'Air Push content',
  PortContainerData: 'Port container data',
  NoCustomerSelected: 'No customer selected.',
  UpdateSuccessful: 'Update successful',
  Seaport: 'Seaport,',
  Airport: 'Airport,',
  ChargeItem: 'Charge item,',
  Route: 'Route,',
  Network: 'Network,',
  Currency2: 'Currency,',
  ContainerType: 'Container type,',
  Packaging: 'Packaging,',
  BillOfLadingType2: 'Bill of lading type,',
  CargoType: 'Cargo type,',
  TradeTerms: 'Trade terms,',
  TransportTerms: 'Transport terms,',
  TradeMode: 'Trade mode,',
  AirFreightServiceItems: 'Air freight service items,',
  RelatedPort: 'Related port,',
  AirCargoBillMiscellaneous: 'Air cargo bill miscellaneous,',
  CustomerType: 'Customer type,',
  BillOfLadingMethod: 'Bill of lading method,',
  CustomBusinessType: 'Custom business type,',
  CirculatingDocumentType: 'Circulating document type',
  Initialize: 'Initialize',
  Success: 'Success',
  Failure: 'Failure',
  AddPort: 'Add port',
  PleaseSelectPort: 'Please select port',
  Operator: 'Operator',
  PleaseSelectPort2: 'Please select port!',
  PleaseSelectOperator: 'Please select an associated user!',
  TheAlreadyMaintainedThisInformation: 'The user has already maintained associated configurations',
  PleaseNameEmailEtcQuery: 'Please enter Chinese name, English name, email etc. for fuzzy query...',
  NetManagementCode: 'Net management code',
  AfterBeAbleToContinue: 'After setting as invalid, the user will not be able to log in to the system, continue?',
  Valid: 'Valid',
  Invalid: 'Invalid',
  PleaseEnterEmail: 'Please enter email',
  EditSuccess: 'Edit success',
  EmailDuplicate: 'Email duplicate!',
  UserAllowsInputLettersNumbers: 'User code only allows input letters and numbers.',
  Operator2: 'Operator:',
  PortCode: 'Port code',
  RelatedUser: 'Related user',
  BusinessMode: 'Business mode',
  PleaseDataYouWantDelete: 'Please select the data you want to delete.',
  AreYouWantToDelete2: 'Are you sure you want to batch delete the {0} selected configuration items?',
  DeleteSuccess2: 'Delete success.',
  AddRoleUser: 'Add role user',
  AddUserWithUnassignedRole: 'Add user with unassigned role',
  Query: 'Query',
  SelectDepartment: 'Select department',
  AreYouWantToDelete3: 'Are you sure you want to delete?',
  SelectedUsersAlreadyExist: 'Selected users already exist',
  AddSuccessfully: 'Add successfully',
  CopyRole: 'Copy role',
  PasteRole: 'Paste role',
  PleaseRoleYouWantCopy: 'Please select the role you want to copy!',
  PleaseYouWantToRole: 'Please select the department where you want to paste the role!',
  IPWhitelist: 'IP whitelist',
  UserWhitelist: 'User whitelist',
  JobNumber: 'Job number',
  NoteMainAndSplit19: 'Note: The job number is up to 21 characters long, with the last two reserved for the main and split order signs, so the order number length set on this page must not exceed 19.',
  MainOrderNumber: 'Main order number',
  NoteNumberIsUpLong: 'Note: The bill of lading serial number is up to 16 characters long.',
  SubOrderNumber: 'Sub-order number',
  NoteIsUpToLong: 'Note: The sub-order number is up to 21 characters long.',
  WarehouseEntryNumber: 'Warehouse entry number',
  BookingNumber: 'Booking number',
  NoteYouHaveSelectedLength: 'Note: The warehouse entry number is up to 21 characters long, if you have selected the job number, please pay attention to its actual length.',
  OverseasBillNumber: 'Overseas bill number',
  NoteIsUpToLong2: 'Note: The overseas bill number is up to 16 characters long.',
  PaymentApplicationForm: 'Payment application form',
  PaymentApprovalForm: 'Payment approval form',
  NoteIsUpToLong3: 'Note: The payment application number is up to 16 characters long.',
  NoteIsUpToLong4: 'Explanation: The longest domestic bill number is 16 digits.',
  BillOfLadingSerialNumber: 'Bill of lading serial number',
  SeaFreightExport: 'Sea freight export',
  SeaFreightImport: 'Sea freight import',
  AirFreightExport: 'Air freight export',
  AirFreightImport: 'Air freight import',
  FBASeaFreight: 'FBA sea freight',
  FBAAirFreight: 'FBA air freight',
  ReportName: 'Report name',
  Report: 'Report',
  PermissionAddedSuccessfully: 'Permission added successfully',
  PleaseReportLinkedToRole: 'Please select the report linked to the role',
  AreToDeleteTheRole: 'Are you sure you want to delete the currently selected role?',
  PermissionDeletedSuccessfully: 'Permission deleted successfully',
  QuickSearchAdTheme: 'Quick search: Ad theme',
  AdCode: 'Ad code',
  AdThemename: 'Ad theme/name',
  AdLocation: 'Ad location',
  BelongsToPage: 'Belongs to page',
  BelongsToModule: 'Belongs to module',
  BelongingSystem: 'Belonging system',
  PageViews: 'Page views',
  Clicks: 'Clicks',
  ClickRate: 'Click rate',
  NumberOfClickUsers: 'Number of click users',
  N0FileTypeNotSelected: '{0} File type not selected.',
  NoteCopyFollowingInformation: 'Note: You have chosen to copy [{0}], which includes the following information:',
  NXRoles: ' roles?',
  BranchSelection: 'Branch selection',
  CheckParentCompanyWithSubsidiary: 'Check the parent company and select the subsidiary company',
  CurrentlySelectedProject: 'Currently selected project:',
  AlertContentConfiguration: 'Alert Content Configuration',
  AlertTimeConfiguration: 'Alert Time Configuration',
  SopTimeSetUp: 'SOP Time Set Up',
  SetPersonalEmail: 'Please set personal email information',
  SetPersonalEmailNote1: "After setting up a personal email, the actual sending email is each user's personal email. Please ensure that each user sets up their personal email correctly.",
  SetPersonalEmailNote2: 'If not set correctly, use the company email and system email as the sending email in sequence.',
  SetPersonalEmailStep1: 'Step 1: Enter Settings and Tools, Personal Email Settings.',
  SetPersonalEmailStep2: 'Step 2: Maintain personal email password/authorization code, sending server, port, and signature information.',
  SetPersonalEmailStep3: 'Step 3: After saving, you can use your personal email as your outgoing email.',
  WhtTax: 'WHT tax',
  WhtTaxTip: 'Thailand and other scenarios containing WHT are applicable. After activation, expenses can be recorded and WHT tax can be deducted for account cancellation.',
  SendDestinationPortProxyDocuments: 'File History - Send destination port proxy documents',
  MainTicketAttachmentItem: 'Main ticket attachment item',
  SmallTicketAttachmentItem: 'Small ticket attachment item',
  SelectFileType: 'Select File Type',
  IncludeSlaveAttachLabel: 'When sending an email with the main ticket, the attachment must include a small ticket file',
  AutoGenerationManifestLabel: 'When there is no MANIFEST file in the main ticket, it is automatically printed according to the box number',
  FileAttachmentTip: 'If you need to verify the existence of attachments when sending them, please set them in the Basic Configuration - Verification Rule Configuration section.',
  FileAttachmentTip2: 'The system automatically matches the corresponding file attachments based on the HBL bill of lading method by default, which can be closed in Basic Configuration Configuration Management.',
  YearMonthEtdTip: 'If both job (year) and job (month) need to be checked, the value will be based on the month and month selected in the [sailing date]',
  YearMonthEtaTip: 'If both job (year) and job (month) need to be checked, the value will be based on the month and month selected in the [arrival date]',
  RiYearMonthEtaTip: 'If both job (year) and job (month) need to be checked, the value will be based on the month and month selected in the [arrival Date]',
  NotifySuperiors: 'Notify superiors',
  NotifySuperiorsCheckTip: "When selecting 'Notify Superior Supervisor', at least one 'Designated Position' must be selected!",
  AddOnlyCurrentTemplate: 'Add only to the current template',
  AddOtherSameLobTempalte: 'Add to other templates under the same business type',
  OnlyModifyCurrentTemplate: 'Only modify the current template',
  ModifyTemplateContaneNode: 'Modify all templates containing this node',
  AddRanges: 'Add Ranges',
  ModifyRanges: 'Modify Ranges',
  ApplicationTemplate: 'Application template',
  SetNodeLimitTip: 'When setting up nodes, the 【Code】, 【Chinese Name】, and 【English Name】 of SOP nodes under the same business type must be consistent.',
  SelectSOPTemplateForNode: 'Select the SOP template for node application',
  ConfirmJoinSelectTemplate: 'Are you sure to add it to the selected SOP template?',
  AddTemplateSameNode: 'Add to all templates of the same node',
  ModifyTemplateContinNode: 'Modify all templates containing the status of this node',
  HblBlWayAttachLabel: 'According to the mode and type of bill of lading of the business, the corresponding HBL file is extracted',
  HblWithoutGenerateAttachLabel: 'Automatically prints HBL proofs when there is no HBL file',
  ConfirmedPrintHblLabel: 'When the HBL status is confirmed but not issued, the HBL proof is automatically printed',
  PleaseSetSlaveAttach: 'Please set the file type for the small ticket attachment item first!',
  QueryFileType: 'Query file type: ',
  HblCfmStateOriginDraftLabel: 'When the HBL status is not issued, the HBL sample is drawn from the attachment; when the HBL has been issued, the HBL copy is drawn from the attachment',
  BillOfLading: 'Bill of Lading',
  AssociatedRoutesAndPorts: 'Associated routes and ports',
  AirlineChineseName: 'Airline chinese name',
  PortEnglishName: 'Port english name',
  OperationPosition: 'Operation position',
  UserConfigDuplicate: '{0} employee already has configuration item data, please do not duplicate configuration.',
  ConfirmSaveModifiedInfo: 'Are you sure you want to save the modified information?',
  PleaseSelectARoute: 'Please select a route',
  AssociatedPermissions: 'Associated permissions',
  OptionalPositionsRoles: 'Optional responsible positions are limited to user roles',
  ResponsiblePosition: 'Responsible for the position',
  SelectResponsiblePosition: 'Please select the responsible position!',
  ConfigApplyRemoteBooking: 'Configure application for remote booking module',
  AssociatedWarehouseSupplier: 'Associated warehouse supplier',
  WarehouseNameCustomsBrokeDestinationAgent: 'Please select an associated configuration item (warehouse name, customs declaration, destination port agent)',
  RelatedCustomsBroker: 'Related customs broker',
  RelatedDestinationAgent: 'Related destination port agent',
  AssociatedWarehouseName: 'Associated warehouse name',
  PortCodeRepeat: '{0} has already been set up, please do not repeat it.',
  RegionCodeRepeat: '{0} route has already been set up, please do not repeat it.',
  DesignatedCargoControlRange: 'Designated cargo control range:',
  RangeOfSelfPickupControl: 'Range of self pickup control',
  WarningConfiguration: 'Warning configuration:',
  AccountsReceivableSettlementUnits: 'All accounts receivable settlement units',
  MailServer: 'mail server',
  MailServerConfigTip: 'Company email must be set up and enabled in [Push Configuration Service] first.',
  PushConfigServiceCompanyEmail: 'You need to first set up your company email and enable it in the Push Configuration Service',
  PushConfigServicePersonalEmail: "Please select a designated position or a designated person's personal email. Before using it, you need to configure your personal email and enable it",
  SelectSendEmail: 'Select the sending email',
  Assigner: 'assigner',
  DeletePrompt: 'Are you sure to delete this account? Have you informed Yundang that this account has been abolished?？',
  EditUser: 'Edit user',
  NewUser: 'New user',
  Password: 'Password',
  CustomerName: 'Customer Name',
  AccountMaintenance: 'Call interface account maintenance',
  Unmaintained: 'You cannot subscribe to port data without providing an account password. Please contact customer service.',
  PortNotNull: 'Port cannot be empty',
  CustomerNotNull: 'Customer name cannot be empty',
  AccountNumberNotNull: 'Account cannot be empty',
  PasswordNotNull: 'Password cannot be empty',
  CustomIdNotNull: 'CustomId cannot be empty',
  PartnerWarehouseCode: 'Partner warehouse entry number code',
  PartnerWarehouseCodeTip: 'When the entrusted unit, designated freight agent, and destination port agent in the business document are all set with warehouse entry numbers, the priority order of values can be set.',
  CheckRuleToAllBranch: 'Validation rules are effective for all subsidiaries',
  CustomDescription: 'Custom Description',
  OnlyPositiveFeePermission: 'No operation permissions. Only positive fees can be added.',
  MultipleTriggers: 'Multiple triggers',
  IsMultipleTriggers: 'IS multiple triggers',
  AllowTriggeringAgainValueChange: 'Allow triggering again when the field value changes',
  OnlyEntityCodeSupportTrigger: 'Only date and string type fields with entity codes: Job/AirExportJob/AirimportJob/IntegratedJob/SeaExportJob/SealportJob support multiple triggers. Please confirm with R&D first!',
  TriggerTypeChangePushMsg: 'Trigger type value change and push message again',
  CheckBaseLabel: 'Only push according to the contact person set in the business document.',
  PushExternalInterfaces: 'Push external interfaces',
  TriggerInternalEvent: 'Trigger internal event',
  TriggerTypeChangePushInterface: 'Trigger type value change and push interface again',
  XhqBillDataUpdate: 'Signal flag bill of lading data update',
  msdBillDataUpdate: 'MSD Bill Data Push API',
  MsdApiLog: 'MSD API Log',
  pushPreConfiguredInformation: 'Push pre-configured information',
  pushMasterData: 'Push all information under current master bill as pre-configuration data. After verification, please click "Confirm"',
  canPushPreConfiguration: 'Pre-configuration Push Enabled',
  AgainPushTitleDisplay: 'The title of the email being pushed again will display the change in the trigger type value. Display for example: booking message [export vessel name and voyage] Originally: SITC → Now: LECANGS; Original: V.088W → Now: 0XSJXS',
  PleaseSelectOpBranch: 'Please select the operating branch!',
  OpOfficeChangeUpdateData: 'The operation branch has been modified. Do you want to update the corresponding position personnel?',
  WarehouseChangeUpdateData: 'The operation branch has been modified. Do you want to update the corresponding warehouse/customs broker/destination port agent?',
  ClassifyName: 'Classification name',
  Sort: 'Sort',
  ClassifyMsgNameEmpty: 'Category name required',
  ClassifyMsgSortEmpty: 'Sort required',
  ClassifyMsgNameRepeat: 'The category name cannot be repeated',
  ClassifyMsgSortRepeat: 'The sort number cannot be repeated',
  ConfirmDeletionOfClassifyMsg: 'Are you sure you want to delete the message category? The corresponding Chinese, English and Japanese versions will be deleted simultaneously!',
  ClassifyMsgDeletedTips: 'This message category has a message notification, can not be deleted!',
  MsgTitle: 'Message header',
  Content: 'Main body',
  ConfirmDeletionOfBellMsg: 'Are you sure you want to delete the message notification? The corresponding Chinese, English and Japanese versions will be deleted simultaneously!',
  BellMsgTitleEmpty: 'The message title is required',
  BellMsgCodeEmpty: 'Code required',
  BellMsgContentEmpty: 'Text required',
  BellMsgTitleRepeat: 'The message title cannot be repeated',
  BellMsgCodeRepeat: 'Non-repeatable code',
  BellMsgContentRepeat: 'Text non-repeatable',
  Language: 'Language',
  Link: 'Jump address',
  LinkTip: 'Skip route is used for the message to jump to the corresponding operation interface, please confirm with R&D before filling in!',
  BellSubscriptionTitle: 'Message subscription Settings',
  BellSubscriptionConf: 'Notification subscription',
  BellSubscribed: 'subscribed',
  BellUnSubscribed: 'Not subscribed',
  MessageConfig: 'Message setting',
  WoBaoIntelligentAssistant: 'WoBao Intelligent Assistant',
  WoBaoSubscriptionTip: 'Wobble Assistant will alert subscribed today unread messages on the page',
  AllMessage: 'Full message',
  TodayUnReadMsg: 'Unread today',
  ViewHQMapping: 'View HQ mapping',
  BranchNotMatchNotOperate: 'Not belonging to the data of this branch, unable to operate',
  UsersAlertNotifyAfterUsingXX: 'Users can configure an alert notification after using XX%.',
  UsersAlertNotifyBeforeExpireDate: 'Users can configure an alert notification to be sent XX days before the expiration date.',
  UnloadingEortEnName: 'The English name of the unloading port',
  OriginPortEnName: 'The English name of the port of origin',
  MatchingCriteriaSelection: 'Matching criteria selection',
  PresetValueConfiguration: 'Preset value configuration',
  MatchingCriteriaSelectionTip: 'Used for matching in business documents, automatically filling in preset values when matching conditions are met.',
  PresetValueConfigurationTip: 'Sea freight exports are calculated based on the ETD for the number of days in advance of the date. Automatically compensate for weekends. When the number of days is 0, it means that the relevant dates will not be automatically calculated.',
  PleaseSelectDeparturePort: 'Please select the port of departure',
  PleaseSelectUnloadingPort: 'Please select the unloading port',
  PleaseSelectCarrier: 'Please select carrier',
  PortRequirementBillRequirements: 'Port requirements (bill of lading requirements)',
  PleaseSaveCurrentDataFirst: 'Please save the current data first',
  RelatedInstructionsAttachments: 'Related instructions and attachments',
  PortRequirementsRelatedDocuments: 'Port requirements related documents',
  NoRelevantDocumentsAvailable: 'No relevant documents available',
  DefaultConfigurationNotes: 'Default configuration notes',
  PleaseSelectMatchingItem: 'Please select a matching item',
  PleaseSetPreset: 'Please set a preset',
  CalculateDateIncludeETDTheDay: 'Calculation of lead time includes the day of ETD',
  SetLeadTimeBasedOnETDTime: 'Set lead time based on ETD time',
  WoBaoSubscribed: 'Open',
  WoBaoUnSubscribed: 'Closed',
  CalculateIncludeEtdIsWeekend: 'The lead time calculation includes ETD on weekends',
  PositionAssociatedRoutePortConfig: 'Position personnel are associated with preset configurations of flight routes/ports',
  PleaseSelectLoadingPort: 'Please select the loading port',
  PleaseSelectOriginatingStation: 'Please select the originating station',
  PleaseSelectDestinationStation: 'Please select the destination station',
  PositionCannotDuplicated: 'The position cannot be duplicated',
  UserHasRepeatConfigData: 'The user already has duplicate configuration data!',
  UserRoleDefaultRepeat: 'Other employees have already configured the default position value for this matching criterion. Are you sure you want to modify it?',
  ChartSource: 'Chart source',
  EnterChartSource: 'Please enter the chart source',
  ToDoNodeRuleSettings: 'To do node rule settings',
  ServiceScenarioApplication: 'Specific business rules',
  SettingApplicationScenarios: 'Business rule setting',
  MainNotToDoTask: 'The main ticket document is not considered a to-do task (LCL scenario)',
  SpecifyRole: 'Specify Role',
  CheckPrivilegePersonLabel: 'Do you want to restrict roles without type permissions from modifying file types',
  SetExclusionOffices: 'Set exclusion offices',
  AccountsReceivable: 'Accounts receivable',
  Just: 'Just',
  NotEntityCompany: 'Non entity company',
  NotEntityCompanyTip: 'When conducting specific financial statement statistics, this indicator needs to be checked.',
  Marked: 'Marked',
  NotSetDefaultValueMultiPosition: 'When the conditions match multiple job positions, the default values are not displayed and manual selection is required!',
  AvailableOfficeOverMaxLimit: 'Your available branch offices have reached the maximum limit. If it is necessary to increase the number of branch offices. You can contact your sales personnel or customer service.',
  AvailableUserOverMaxLimit: 'You have reached the maximum number of available users. If it is necessary to increase the number of users. You can contact your sales personnel or customer service.',
  BranchCountExpireLimitUse: 'Dear user, the extension branch you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">The current branch office will be restricted from accessing and data will be retained. After renewal, it can be used again.</div>',
  UserCountExpireLimitUse: 'Dear user, the number of extended users you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">The current user will be restricted to disabled and data will be retained. After renewal, it can be reactivated for use.</div>',
  UserCountExpireLimitAdmin: 'Dear user, the number of extended users you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">The current user (excluding system administrators) will be restricted to disabled and data will be retained. After renewal, it can be reactivated for use.</div>',
  OpenConfig: 'Open Config',
  SendType: 'Send Type',
  Key: 'Key',
  UserPwd: 'User Pwd',
  OpenConfigTip: 'After activation, the template is sent according to the configured {0}',
  NotEmptyTips: 'The blue field is a required field!',
  MustBeNumericType: '{0}Must Be Numeric Type',
  MainTicket: 'Main ticket',
  SlaveTicket: 'Slave ticket',
  Alias: 'Alias',
  SetAlias: 'Set alias',
  AliasOnlyHQ: 'Set aliases uniformly only under HQ',
  HideCategoryAllLanguage: 'Hide this category (applies to all language versions)',
  FieldDisplayHideForbid: 'When there are fields with display status under the category, hiding is not allowed!',
  HQSavePrompt: 'HQ Save Prompt',
  BranchSavePrompt: 'Office Save Prompt',
  OnlyDisplayMandatoryRule: 'Only adjust the display of fields and mandatory rules, without covering the display order of fields on custom pages for branch offices and employees!',
  DisplayMandatorySort: 'Adjust the display of fields and mandatory rules, and reset the field display order of custom pages for subsidiaries and employees according to HQ rules!',
  AdjustOrderConfig: 'This item will adjust the order of the configured interfaces for all subsidiaries and employees to the setting order of HQ!',
  OfficeOnlyDisplayMandatoryRule: "Only adjust the display of fields and mandatory rules, without covering the display order of fields on employees' custom pages!",
  OfficeDisplayMandatorySort: "Adjust the display of fields and mandatory rules, and reset the field display order of employees' custom pages according to branch rules!",
  OfficeAdjustOrderConfig: 'This item will adjust the interface order that employees have already configured to the setting order of the branch company!',
  ApplyHQSetting: 'Are you sure to apply the headquarters settings?',
  ResetCustomSetConfirm: 'Are you sure to reset the custom settings for this tab? This operation is irreversible, please confirm!',
  HQSettingNotEditAlias: 'When applying HQ settings, branches cannot make edits or adjustments. Alias settings are uniformly configured under HQ only.',
  NonLoginUser: 'Non-logged in system user',
  ValidUserNotNeedLogin: 'Among valid users, users who do not need to log in to the system',
  NotLoginUserContactAdmin: 'The system administrator has set you as a user who does not require logging into the system. If you need to use the operating system, please contact your administrator to make adjustments and log in again.',
  FinanceExpireLimitUse: 'Dear user, the financial management module you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">Please renew and continue using. You can contact your salesperson or customer service.</div>',
  EdiExpireLimitUse: 'Dear user, the EDI booking interface you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.',
  TaxExpireLimitUse: 'Dear user, you have not activated the tax control service, or the tax control service you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.',
  EntrustPageTab: 'Entrustment page tab',
  ExportEntrustPageTab: 'Export entrustment page tab',
  ImportEntrustPageTab: 'Import entrustment page tab',
  AttachmentRuleConfig: 'Attachment rule configuration',
  BusinessOrdersAttachments: 'When the business is divided into formal orders, attachments are extracted and divided into formal orders',
  SendPackageProxyFiles: 'File History - Send Package Proxy Files',
  BillNotStartNoneFile: 'When the HBL bill of lading status has not started or is pending confirmation, no bill of lading documents (including samples) will be extracted',
  LockAfterSend: 'Lock after sending:',
  SendLockSlaveHblAndVirtualBill: 'After sending, lock the HBL and form split tab of the receipt (including splitting/merging)',
  SendLockExchangeAgentHblAndVirtualBill: 'After sending, lock the HBL tab and form splitting tab (including splitting/merging) of the corresponding exchange agent',
  AutoPrintManifestAfterAllHblConfirm: 'Automatically print MAINFEST files (including HBL split orders) only after all HBL bill of lading statuses have been confirmed',
  BusinessDataNotUpdate: 'Do not automatically update job personnel when updating business data',
  AutoPrintRule: 'Automatic printing rule',
  EmailAttachRule: 'Rules for extracting email attachments',
  FormalDivisionRule: 'Formal division rules',
  BusinessIfVirtualBillOnlyAttachment: 'If a service has a formal sub-order, only the formal sub-order file is extracted from the attachment',
  SetFileSyncRule: 'Set file synchronization rules',
  BusinessModel: 'Business model:',
  SyncDirection: 'Synchronization direction:',
  SyncCondition: 'Synchronization Condition',
  SyncFileToApprovedDoc: 'Files can be synchronized to approved documents',
  DeleteFile: 'Delete file:',
  SyncMode: 'Synchronization mode:',
  CrossDelegation: 'Cross delegation',
  PrincipalOperator: 'Principal ->Operator',
  OperatorClient: 'Operator ->Client',
  SyncFileDeletion: 'Synchronize file deletion',
  NotDeleteRelateFile: "Do not delete the other party's files",
  ManualSync: 'Manual synchronization',
  AutoSync: 'Automatic synchronization',
  ExportToImport: 'Export to Import',
  ExporterImporter: 'Exporter ->Importer',
  ImporterExporter: 'Importer ->Exporter',
  BbSendDestinationPortAgent: 'Entrust LCL to send destination port agent documents',
  ChargeSyncAuditPass: 'Fees are synchronized - approved',
  ChargeSyncAuditNotPass: 'Fees are synchronized  - Review not passed',
  ChargeSyncRecallApplyCharge: 'Fees are synchronized - withdrawal application fees',
  SendEmailByPositionPersonnel: 'The email will be pushed to the set position personnel of the sender',
  AttachmentItems: 'Attachment Items',
  PleaseSetAttach: 'Please set the attachment item file type first!',
  SendLockHblAndVirtualBill: 'After sending, lock the HBL and form split tab of the business (including splitting/merging)',
  AirOperationTAB: 'Air Operations TAB',
  CurrentPageNewFieldTip: 'There are new fields on the current TAB page. Click Edit to add fields.',
  SystemAddedItem: 'A field item is added to the system',
  DragTheBlockUse: 'Please drag and drop the field to the corresponding block to use it',
  CustomTemplateMustSelect: 'Custom template name must select one piece of information',
  VirtualBillHBLNO: 'Virtual Bill HB/L NO',
  TemplateRemarks: 'Template Remarks',
  AutomPrintDefaultFileType: 'Automatically print the default file type',
  PopupMode: 'Popup Mode',
  DisplayWhenThereIsValidation: 'Display the validation information popup only when there is an error message during validation.',
  TheBeAppliedToOffices: 'The pop-up mode will be applied to all branch offices.',
  VerificationNodeCannotBeEmpty: '[Verification Node] cannot be empty',
  VerificationModeCannotBeEmpty: '[Verification Mode] cannot be empty.',
  CustomerOfLadingOptionIssue: 'Customer self-issue (Bill of Lading option: Customer self-issue)',
  WhenLadingHasBeenDocuments: 'When a customer submits their own documents and the bill of lading has been confirmed or issued, extract the customer\'s self-submitted documents.',
  WhenIsNeitherConfirmedExtracted: 'When a customer submits their own bill of lading document, and the bill of lading is neither confirmed nor issued, the customer\'s self-submitted bill of lading will not be extracted.',
  WhenOfLadingHasSample: 'When there is no customer-issued document and the bill of lading has been confirmed but not issued, automatically print a sample.',
  ApplicationModule: 'Application modules',
  UICustomisation: 'UI customisation',
  SOPPanel: 'SOP panel',
  InvokeAutomatedExecution: 'Invoke Automated Execution',
  FileHistoryTab: 'File History tab',
  ViewOpInstruction: 'View the operation instructions',
  SetOpInstruction: 'Set the operation instructions',
  HeadquartersSetupForCommandApplications: 'Headquarters Setup for Command Applications',
  SetCommandParameters: 'Set command parameters',
  DisplayRuleSettings: 'Display Rule Settings',
  PleaseCommandForAScenario: 'Please set an operation command for a specified scenario.',
  CommandParameters: 'Command Parameters',
  SceneRules: 'Scene Rules',
  SceneParameters: 'Scene Parameters',
  CommandApplication: 'Command Application',
  TheStatusOfAllProcesses: 'The manifest (including split orders) is automatically printed only after the status of all HBLs has been confirmed when sending according to business processes.',
  WhenOnlyAfterTheConfirmed: 'When sending by container, the MAINFEST (including split orders) is automatically printed only after the status of all HBLs corresponding to the container has been confirmed.',
  TheLettersAndBeLength: 'The password must contain numbers, lowercase letters, uppercase letters, and be between 8 and 20 characters in length.',
  WhenIssuesBillOfExtracted: 'When the customer issues the bill of lading themselves (selecting "customer issues bill of lading"), only the customer-issued bill of lading is extracted.',
  SetBlockWidth: 'Set block width',
  SettableRange300400: 'Settable range: 300-400',
  DisplaySettings: 'Display Settings',
  ApplicationSettings: 'Application Settings',
  ReadAndWriteSettings: 'Read and Write Settings',
  CanEditable: 'editable',
  VisibleToDesignatedPersonnel: 'Visible to designated personnel:',
  FieldPermissionSettings: 'Field Permission Settings',
  CanWrite: 'Can write',
  FieldNameQuery: 'Field Name Query',
  TheAsTheOceanConfiguration: 'The alias of the booking pre-review field is the same as the ocean freight booking settings and does not support independent configuration!',
  TheAsThoseForConfiguration: 'The field aliases for ocean freight booking entrustment are the same as those for ocean freight booking settings and do not support independent configuration!',
  TheAsTheAirConfiguration: 'The field alias for air freight booking is the same as the air freight booking settings and does not support independent configuration!',
  TheThoseInTheConfiguration: 'The field aliases for railway booking entrustment are the same as those in the railway operation settings and do not support independent configuration!',
  TheOrderInTheConfiguration: 'The order pre-screening field alias is aligned with the air freight booking settings and does not support independent configuration!',
  FillInMode: 'Fill-in Mode',
  SingleTicketBusinessForm: 'Single ticket business form',
  BulkProcessing: 'Bulk processing',
  SingleFormSubmission: 'Single form submission',
  BatchFillOutForms: 'Batch fill out forms',
  SelectionForm: 'Selection form',
  TriggerNodeStatesupConfigured: 'Trigger rollback of other node states (up to 5 configured)',
  RollbackBeSetOnlyStartedAbnormal: 'Rollback to the status of other nodes can be set only when [Status Type] is [Not Started]/[Abnormal].',
  PleaseNodeThatNeedsTriggered: 'Please set a rollback node that needs to be triggered',
  TheNodeCannotBeEmpty: 'The node cannot be empty',
  TheStatusCannotBeEmpty: 'The node status cannot be empty',
  AllowStatusToTriggerRollback: 'Allow the node status to trigger a rollback',
  SOPRestrictionsForBusinessDocuments: 'SOP template matching restrictions for business documents',
  OnlyForTheBranchTemplate: 'Only the application operations set for the branch and HQ template',
  OnlyOperationDepartmentAndTemplate: 'Only the designated application operation department and HQ template',
  TabSettings: 'Tab Settings',
  StandardFeesTab: 'Standard Fees Tab',
  HideStandardFeeTab: 'Hide Standard Fee Tab',
  DisplayAsASeparateTab: 'Display as a separate tab',
  DropdownBoxValueDisplay: 'Dropdown box value display:',
  DisplayRecentlyUsed50Values: 'Display the most recently used 50 data values',
  DisplayOrderLogic: 'Display order logic:',
  TheFirstValueTheSequentially: 'The most recently saved data will be displayed as the first value, the previous save as the second, and so on sequentially.',
  InstructionPermissions: 'Instruction Permissions',
  AllPositions2: 'All positions',
  PleaseAPositionOrPersonnel: 'Please select a position or personnel',
  SalesModule: 'Sales Module',
  SalesInquiry: 'Sales Inquiry',
  SalesInquiryApplication: 'Sales Inquiry Application',
  SalesTheCustomTabUI: 'Sales inquiry allows displaying the custom tab of this UI',
  DisplayCargoPackingInformation: 'Display cargo packing information',
  ControlPropertyConfiguration: 'Control Property Configuration',
  WhenMainTicketDisplayMode: 'When the business document is the main ticket, display the main ticket packing mode.',
  UpdatePortDataButton: 'Update port data button',
  UIFieldConfiguration: 'UI Field Configuration',
  AutomatedExecution: 'Automated execution',
  SOPStatusTrigger: 'SOP status trigger',
  TriggerBasedOnFieldValue: 'Trigger based on field value',
  DocumentInfo: 'Document Information',
  DocumentTemplate: 'Document Template',
  LocalizedTemplateName: 'Localized Template Name',
  TemplateId: 'Template ID',
  TemplateType: 'Template Type',
  TemplateStatus: 'Template Status',
  TemplateDescription: 'Template Description',
  LocalizedTemplateDescription: 'Localized Template Description',
  ApplicableCarrier: 'Applicable Carrier',
  ApplicableSeaport: 'Applicable Port',
  PleaseEnterLocalTemplateName: 'Please enter the local template name',
  TemplateEnabledPrompt: '【{0}】 - 【{1}】 file is correct. After enabling, it may be used by users in business operations.',
  TemplateDisabledPrompt: '【{0}】"- {1}】 will not be searchable or usable by users in business operations once disabled.',
  TemplateDeletedPrompt: 'Please confirm whether 【{0}】 - 【{1}】 has been deleted.',
  TriggeredToSpecificBusinessRules: 'Triggered according to specific business rules',
  InvoiceInquiryTab: 'Invoice Inquiry Tab',
  SetFieldValueSynchronization: 'Set field value synchronization',
  SourceTab: 'Source tab',
  SourceField: 'Source field',
  WriteTab: 'Write tab',
  WriteField: 'Write field',
  SyncOnlyAtCreation: 'Sync only at creation',
  SynchronizedReceiptWithMainTicket: 'Synchronized receipt with main ticket',
  AreWantToDeleteData: 'Are you sure you want to delete the selected data?',
  TheFieldCannotBeEmpty: 'The 【{0}】 field cannot be empty.',
  ConfirmFieldValueSynchronizationConfiguration: 'Confirm the field value synchronization configuration?',
  ShippingInformationNonMainInvoice: 'Shipping Information - Non-main Invoice',
  ConfirmBatchModification: 'Are you sure to confirm batch modification?',
  PleaseSelectFillModeAndForm: 'Please select fill mode and form!',
  FillFormCannotBeEmpty: 'Fill form cannot be empty!',
  BatchModificationPrompt: 'Batch Modification Prompt',
  ConfirmBatchModification: 'Are you sure you want to batch modify? This operation will batch modify all selected tasks.',
  BatchModificationConfirm: 'Batch Modification Confirmation',
  TemplateApplicationSettings: 'Template Application Settings',
  MatchingSettings: 'Matching Settings',
  ManualSOPTemplatesIsAllowed: 'Manual replacement of SOP templates is not allowed.',
  DoTemplateIsAutomaticallyTemplate: 'Do not show a prompt when the template is automatically matched to a new template.',
  ContainerMaxNumTip: 'Boxes cannot exceed [{0}]. If you have a need to exceed this limit, please contact customer service to adjust the [ContainerMaxNum] parameter threshold.',
  BatchOperationSettings: 'Batch Operation Settings',
  BatchOperationsSupported: 'Batch operations supported',
  BulkOperationPrompt: 'Bulk Operation Prompt',
  PleaseSelectRailwayExportServices: 'Please select railway export services',
  PleaseSelectRailwayImportBusiness: 'Please select railway import business',
  BatchAllowedPleaseSelectRecord: 'Batch operations are not allowed. Please select a single record.',
  AreWantToPerformOperation: 'Are you sure you want to perform the batch operation?',
  NonNotSupportCrossTenants: 'Non-group companies do not support cross-delegation among tenants.',
  NoBusinessCanBeEntrusted: 'No business can be entrusted',
  PleaseSelect0: 'Please select {0}',
  ShippingInformationMasterBill: 'Shipping Information - Master Bill',
  HideDefaultButton: 'Hide default button',
  AdditionalReceivables: 'Additional Receivables',
  AdditionalPayable: 'Additional Payable'
}
